/** Reader body text font presets (persisted as `readerOpts.bodyFont`). */
export const READER_BODY_FONTS = [
  'fira-code',
  'noto-sans',
  'crimson-text',
  'nunito',
] as const

export type ReaderBodyFont = (typeof READER_BODY_FONTS)[number]

export const READER_BODY_FONT_DEFAULT: ReaderBodyFont = 'fira-code'

export function isReaderBodyFont(id: unknown): id is ReaderBodyFont {
  return typeof id === 'string' && (READER_BODY_FONTS as readonly string[]).includes(id)
}

export function readerFontFamily(id: string | undefined): string {
  switch (id) {
    case 'noto-sans':
      return "'Noto Sans', system-ui, sans-serif"
    case 'crimson-text':
      return "'Crimson Text', Georgia, serif"
    case 'nunito':
      return "'Nunito', system-ui, sans-serif"
    default:
      return "'Fira Code', ui-monospace, monospace"
  }
}
